// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__CrazM","cell":"ColumnAccessor_cell__11vfD","firstCellAccent":"ColumnAccessor_firstCellAccent__1rkt0"};